import { useTranslation } from "react-i18next";
import { Tooltip } from "src/components/Default/LekUI/Tooltip";
import SimulationIcon from "src/images/Icons/newIcons/simulation.svg";

export const LearningExamType = () => {
	const { t } = useTranslation();
	return (
		<Tooltip title={t("tooltips.simulationWithoutTimer")}>
			<div className="menu-icon-button flex-center-row p-6 border-radius-6">
				<SimulationIcon className="icon-small" />
			</div>
		</Tooltip>
	);
};
